import API from "../../services/api";

// =============================
// Dashboard
// =============================

export const getDashboard = () =>
    API.get("/admin/dashboard");

// =============================
// Providers
// =============================

export const getProviders = () =>
    API.get("/admin/providers");

export const getPendingProviders = () =>
    API.get("/admin/providers/pending");

export const getProvider = (id) =>
    API.get(`/admin/providers/${id}`);

export const approveProvider = (id) =>
    API.put(`/admin/providers/${id}/approve`);

export const rejectProvider = (id, reason) =>
    API.put(`/admin/providers/${id}/reject`, {
        reason,
    });

export const suspendProvider = (id) =>
    API.put(`/admin/providers/${id}/suspend`);

export const activateProvider = (id) =>
    API.put(`/admin/providers/${id}/activate`);

export const deleteProvider = (id) =>
    API.delete(`/admin/providers/${id}`);

// =============================
// Customers
// =============================

export const getCustomers = () =>
    API.get("/admin/customers");

export const getCustomer = (id) =>
    API.get(`/admin/customers/${id}`);

export const blockCustomer = (id) =>
    API.put(`/admin/customers/${id}/block`);

export const unblockCustomer = (id) =>
    API.put(`/admin/customers/${id}/unblock`);

export const deleteCustomer = (id) =>
    API.delete(`/admin/customers/${id}`);

// =============================
// Delivery Partners
// =============================

export const getDeliveryPartners = () =>
    API.get("/admin/delivery");

export const getDeliveryPartner = (id) =>
    API.get(`/admin/delivery/${id}`);

export const approveDeliveryPartner = (id) =>
    API.put(`/admin/delivery/${id}/approve`);

export const rejectDeliveryPartner = (id) =>
    API.put(`/admin/delivery/${id}/reject`);

export const suspendDeliveryPartner = (id) =>
    API.put(`/admin/delivery/${id}/suspend`);

export const activateDeliveryPartner = (id) =>
    API.put(`/admin/delivery/${id}/activate`);

// =============================
// Categories
// =============================

export const getCategories = () =>
    API.get("/admin/categories");

export const addCategory = (data) =>
    API.post("/admin/categories", data);

export const updateCategory = (id, data) =>
    API.put(`/admin/categories/${id}`, data);

export const deleteCategory = (id) =>
    API.delete(`/admin/categories/${id}`);

// ==========================================
// Food Management
// ==========================================

export const getFoods = () =>
    API.get("/admin/foods");

export const getFoodById = (id) =>
    API.get(`/admin/foods/${id}`);

export const enableFood = (id) =>
    API.put(`/admin/foods/${id}/enable`);

export const disableFood = (id) =>
    API.put(`/admin/foods/${id}/disable`);

export const deleteFood = (id) =>
    API.delete(`/admin/foods/${id}`);
// ==========================================
// Order Management
// ==========================================

export const getOrders = () =>
    API.get("/admin/orders");

export const getOrderById = (id) =>
    API.get(`/admin/orders/${id}`);

export const updateOrderStatus = (id, status) =>
    API.patch(`/admin/orders/${id}/status`, {
        status,
    });

export const updatePaymentStatus = (id, paymentStatus) =>
    API.patch(`/admin/orders/${id}/payment-status`, {
        paymentStatus,
    });

export const assignDeliveryPartner = (id, deliveryPartnerId) =>
    API.patch(`/admin/orders/${id}/assign-delivery`, {
        deliveryPartnerId,
    });

export const deleteOrder = (id) =>
    API.delete(`/admin/orders/${id}`);

// ===============================
// Payment APIs
// ===============================

// Get All Payments
export const getPayments = () =>
    API.get("/admin/payments");

// Get Payment Details
export const getPaymentById = (id) =>
    API.get(`/admin/payments/${id}`);

// Update Payment Status
export const updateAdminPaymentStatus = (id, status) =>
    API.patch(`/admin/payments/${id}/status`, {
        status,
    });

// Process Refund
export const processRefund = (id, data) =>
    API.patch(`/admin/payments/${id}/refund`, data);

// Complete Settlement
export const processSettlement = (id) =>
    API.patch(`/admin/payments/${id}/settlement`);

// Delete Payment
export const deletePayment = (id) =>
    API.delete(`/admin/payments/${id}`);

// ===============================
// Reports APIs
// ===============================

// Dashboard Report
export const getDashboardReport = (filter = "30days") =>
    API.get(`/admin/reports/dashboard?filter=${filter}`);

// Export Report (optional - for later)
export const exportReport = (type = "pdf", filter = "30days") =>
    API.get(
        `/admin/reports/export?type=${type}&filter=${filter}`,
        {
            responseType: "blob",
        }
    );

    // ===============================
// Notification APIs
// ===============================

// Get Statistics
export const getNotificationStats = () =>
    API.get("/admin/notifications/stats");

// Get All Notifications
export const getNotifications = () =>
    API.get("/admin/notifications");

// Get Notification Details
export const getNotificationById = (id) =>
    API.get(`/admin/notifications/${id}`);

// Create Notification
export const createNotification = (data) =>
    API.post("/admin/notifications", data);

// Update Notification
export const updateNotification = (id, data) =>
    API.put(`/admin/notifications/${id}`, data);

// Delete Notification
export const deleteNotification = (id) =>
    API.delete(`/admin/notifications/${id}`);

// Send Notification
export const sendNotification = (id) =>
    API.post(`/admin/notifications/${id}/send`);

// Schedule Notification
export const scheduleNotification = (id, data) =>
    API.post(
        `/admin/notifications/${id}/schedule`,
        data
    );
    // ===============================
// Review APIs
// ===============================

// Get Review Statistics
export const getReviewStats = () =>
    API.get("/admin/reviews/stats");

// Get All Reviews
export const getReviews = () =>
    API.get("/admin/reviews");

// Get Review Details
export const getReviewById = (id) =>
    API.get(`/admin/reviews/${id}`);

// Approve Review
export const approveReview = (id) =>
    API.put(`/admin/reviews/${id}/approve`);

// Hide Review
export const hideReview = (id) =>
    API.put(`/admin/reviews/${id}/hide`);

// Restore Review
export const restoreReview = (id) =>
    API.put(`/admin/reviews/${id}/restore`);

// Reply to Review
export const replyToReview = (id, message) =>
    API.put(`/admin/reviews/${id}/reply`, {
        message,
    });

// Delete Review
export const deleteReview = (id) =>
    API.delete(`/admin/reviews/${id}`);

// =====================================================
// COUPONS API
// =====================================================

// Get All Coupons
export const getCoupons = () =>
    API.get("/admin/coupons");

// Coupon Statistics
export const getCouponStats = () =>
    API.get("/admin/coupons/stats");

// Get Coupon By ID
export const getCouponById = (id) =>
    API.get(`/admin/coupons/${id}`);

// Create Coupon
export const createCoupon = (data) =>
    API.post("/admin/coupons", data);

// Update Coupon
export const updateCoupon = (id, data) =>
    API.put(`/admin/coupons/${id}`, data);

// Change Coupon Status
export const changeCouponStatus = (id, status) =>
    API.put(`/admin/coupons/${id}/status`, {
        status,
    });

// Delete Coupon
export const deleteCoupon = (id) =>
    API.delete(`/admin/coupons/${id}`);

// ==========================
// Earnings
// ==========================

export const getEarnings = () =>
    API.get("/admin/earnings");

export const getEarningById = (id) =>
    API.get(`/admin/earnings/${id}`);

export const getEarningStats = () =>
    API.get("/admin/earnings/stats");

export const getRevenueChart = () =>
    API.get("/admin/earnings/chart");

export const getTopProviders = () =>
    API.get("/admin/earnings/providers");

export const getSettlements = () =>
    API.get("/admin/settlements");

export const getSettlementStats = () =>
    API.get("/admin/settlements/stats");

export const getSettlementById = (id) =>
    API.get(`/admin/settlements/${id}`);

export const getCampaigns = () =>
    API.get("/admin/campaigns");

export const getCampaignStats = () =>
    API.get("/admin/campaigns/stats");

export const getCampaignById = (id) =>
    API.get(`/admin/campaigns/${id}`);

export const createCampaign = (data) =>
    API.post("/admin/campaigns", data, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });

export const updateCampaign = (id, data) =>
    API.put(`/admin/campaigns/${id}`, data);

export const deleteCampaign = (id) =>
    API.delete(`/admin/campaigns/${id}`);

export const uploadCampaignBanner = (formData) =>
    API.post("/admin/campaigns/upload", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });

    export const getActiveBanners = () =>
    API.get("/campaigns/banners");

export const sendEmailCampaign = (data) =>
    API.post("/admin/campaigns/email", data);

export const sendSMSCampaign = (data) =>
    API.post("/admin/campaigns/sms", data);

export const sendPushCampaign = (data) =>
    API.post("/admin/campaigns/push", data);